import React, { Component } from 'react';
import createHistory from 'history/createHashHistory';

import evn from "./../../../../../actions/index";//action的所有事件
import { connect } from "react-redux";//联系store的组件
import EventSet from "./../../../../../assets/PubJs/hcPub";//公用的所有事件
import $ from 'jquery';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import companyCase from "./../../../../../assets/images/companyCase.png";
import cuiBan from "./../../../../../assets/images/cuiban.png";  //催办图标
import Crumbs from './../../../Crumbs/Crumbs';
import CaseDetailsInfoModal from "./../../../Common/CaseDetailsInfoModal";//登记单详情
import "./../style.css";
import { data_Url,Hcurl,HcurlOther } from "./../../../../../constants/index";//获取公共路径
import { TreeSelect,Form, Row, Col,Tag , Input, Button, Table,Switch, LocaleProvider, Modal, Radio ,message,Upload, Checkbox, Tooltip,InputNumber , Icon,Select,Drawer,Collapse,Descriptions,Badge,Tree } from 'antd';
const confirm = Modal.confirm;
const FormItem = Form.Item;
const { TextArea } = Input;
const { Panel } = Collapse;
let timeout;
const history = createHistory();
//var webUrl = 'http://211.149.250.2:20001/wisdom315_BusinessAPI/api/Business/';
//var localValue = JSON.parse(localStorage.getItem('userInfo'));
var filePath = '';
function isInArray(arr, value) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i].Com_CodeAndName.indexOf(value) < 0) {
            var arrary = [];
            arrary.push(arr[i].Com_CodeAndName);

        } else {
         
        }
    }

}


//人员选择
let _PersonChange = null
class PersonChange extends React.Component {
    state = {
        visible: false,
        value: '',
        expandedKeys: [],
        autoExpandParent: true,
        checkedKeys: [],
        selectedKeys: [],
        selectData: [],
        personData: [],
        rightPerson: [],
        beiY: [],
        mrCode: JSON.parse(localStorage.getItem('UserInfo')).UserOrgCode,
        expendCode: [JSON.parse(localStorage.getItem('UserInfo')).UserOrgCode],
        personNum: 0,
        rightPersonkeys: []
    }
    componentDidMount() {
        _PersonChange = this
    }
    handleCancel = () => {
        this.setState({
            visible: false,
            checkedKeys: [],
        })
    }
    getPersonData = () => {
        var arr = new Array();
        arr[0] = this.state.mrCode;
        var result = ReturnValue("Sys_OrganizeLogic", "GetUserByOrganizeCode", arr, "../");
        _PersonChange.setState({
            personData: JSON.parse(result),
            expandedKeys: JSON.parse(result).map(item => { return item.value })
        })
    }
    handleChange = () => {

    }
    getPersonSelect = () => {
        var arr = new Array();
        var result = ReturnValue("Sys_OrganizeLogic", "GetOrganizeList", "", "../");
        if (result == null || result == '') {
            this.setState({
                selectData: []
            })
        } else {
            this.setState({
                selectData: JSON.parse(result)
            })
        }
    }
    onChange = value => {
        this.setState({
            mrCode: value,
            checkedKeys: _PersonChange.state.rightPerson.map((item) => {
                return item.key
            })
        });
        setTimeout(() => {
            _PersonChange.getPersonData()
        }, 100)
    };
    changeExpand = value => {
        this.setState({ expendCode: value });
    }
    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    };

    onCheck = (checkedKeys, e) => {
        let wuC = e.checkedNodesPositions.filter(si => {
            return (si.node.props['children'] && !si.node.props['children'].length)
        }).map(item => {
            return {
                title: item.node.props.title,
                key: item.node.key
            }
        })

        let selectData = e.node.props['children'] && e.node.props['children'].map(item => {
            return {
                title: item.props.dataRef.title,
                key: item.props.dataRef.value
            }
        })
        selectData.push({ key: e.node.props.eventKey, title: e.node.props.title })
        let selectDatas = selectData.filter(si => { return this.state.personData.map(sii => { return sii.value }).indexOf(si.key) == -1 })

        let arr = wuC;
        arr = wuC.filter(si => { return this.state.personData.map(sii => { return sii.value }).indexOf(si.key) == -1 })
        wuC = arr
        let datas = this.state.rightPerson
        let abc = this.state.sendRightPerson
        if (!e.checked) {
            datas = this.state.rightPerson.filter(item => { return selectDatas.map(si => { return si.key }).indexOf(item.key) == -1 })
            let abcd = this.state.sendRightPerson.filter(item => { return selectDatas.map(si => { return si.key }).indexOf(item.key) > -1 })
            if (abcd && abcd.length > 0) {
                var cba = [];
                abc.forEach((item) => {
                    let filterArray = abcd.map(si => { return si.key })
                    if (filterArray.indexOf(item.key) == -1) {
                        cba.push(item)
                    }
                })
                abc = cba
            }
        }
        var allPerson = abc
        allPerson = allPerson.concat(wuC).concat(datas)
        allPerson = allPerson.flat()



        let arrs = []
        allPerson.forEach(si => {
            if (arrs.length == 0) {
                arrs.push(si)
            } else if (arrs.map(item => { return item.key }).indexOf(si.key) == -1) {
                arrs.push(si)
            }
        })
        let rightKeys = arrs.map((item) => {
            return item.key
        })

        this.setState({
            checkedKeys,
            rightPerson: arrs,
            beiY: e.checkedNodesPositions,
            rightPersonkeys: rightKeys,
            sendRightPerson: []
        });

    };


    onSelect = (selectedKeys, info) => {
        this.setState({ selectedKeys });
    };

    renderTreeNodes = data =>
        data.map(item => {
            if (item['children']) {
                return (
                    <TreeNode title={item.title} key={item.value} dataRef={item} >
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.value} {...item} disabled />;
        });
    DelectPerson = (e) => {
        const _this = this;
        var aaa = this.state.checkedKeys.filter((item) => {
            return item != e
        })

        let abc = '';
        _this.state.beiY.forEach(si => {
            si.node.props.children.length && si.node.props.children.forEach(sii => {
                if (sii.key == e) {
                    abc = si.node.key

                }
            })
        })
        this.setState({
            checkedKeys: this.state.checkedKeys.filter(item => {
                return item != e && item != abc
            }),

            rightPerson: this.state.rightPerson.filter((item) => {
                return item.key != e
            }),
            personNum: this.state.rightPerson.filter((item) => {
                return item.key != e
            }).length,
            rightPersonkeys: this.state.rightPerson.filter((item) => {
                return item.key != e
            }).map((item) => {
                return item.key
            }),
        })
    }
    handleOk = () => {
        this.setState({
            visible: false

        })
        var keys = this.state.rightPerson.map((item) => {
            return item.key
        })
        _ClosingFeedback.props.form.setFieldsValue({ receivePerson: keys })


        _ClosingFeedback.setState({
            checkedKeys: keys
        })
    }
    render() {
        const _this = this;
        return (
            <div>
                <Modal
                    title='选择人员'
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width="860px"
                    footer={[
                        <Button onClick={this.handleCancel}>
                            取消
                         </Button>, <Button type="primary" disabled={(this.state.rightPerson.length > 20 || this.state.rightPerson.length==0) ? true : false} onClick={this.handleOk}>
                            确定
                         </Button>

                    ]}
                >

                    <div style={{ width: '100%', height: '580px' }}>
                        <div style={{ float: 'left', width: '530px', height: '580px' }}>
                            <div style={{ marginTop: '-18px' }}>选择：</div>
                            <div style={{ border: '1px solid #e8e8e8', width: '100%', height: '570px', borderRadius: '5px', marginTop: '30px', padding: '24px', paddingTop: '0' }}>
                                <div>
                                    <p style={{ lineHeight: '36px' }}>机构选择：</p>
                                    <TreeSelect
                                        style={{ width: '350px' }}
                                        value={this.state.mrCode}
                                        treeExpandedKeys={this.state.expendCode}
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        treeData={this.state.selectData}
                                        onTreeExpand={this.changeExpand}
                                        placeholder="Please select"
                                        onChange={this.onChange}
                                    />
                                </div>
                                <Tree
                                    checkable
                                    onExpand={this.onExpand}
                                    expandedKeys={this.state.expandedKeys}
                                    autoExpandParent={this.state.autoExpandParent}
                                    onCheck={this.onCheck}
                                    checkedKeys={this.state.checkedKeys}
                                    onSelect={this.onSelect}
                                    selectedKeys={this.state.selectedKeys}

                                >
                                    {this.renderTreeNodes(this.state.personData)}
                                </Tree>
                            </div>
                        </div>
                        <div style={{ float: 'left', width: '250px', height: '570px', border: '1px solid #e8e8e8', borderRadius: '5px', marginLeft: '24px', marginTop: '4px' }}>
                            <div style={{ width: '100%', height: '40px', lineHeight: '40px', borderBottom: '1px solid #e8e8e8', paddingLeft: '10px' }}>
                                已选：{this.state.rightPerson.length}/20
                            </div>
                            <div style={{ width: '100%', height: '535px', overflowY: 'auto' }} >
                                <div>
                                    {this.state.rightPerson.map((item) => {
                                        return (<div key={item.key} style={{ display: 'inline-block', background: '#f7f7f7', borderRadius: '2px', position: 'relative', padding: '3px', margin: '5px' }}>{item.title}<Icon onClick={() => this.DelectPerson(item.key)} style={{ cursor: 'pointer' }} type="close" /></div>)
                                    })}
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}


//反馈抽屉
let _FeedBackDawer = null
class FeedBackDawer extends React.Component{
    state={
        visible:false,
        showBox:true,
        dataName: '',
        fileList: [],
        checkedState:true,
        resultValue:'和解成功',
        paymentMoney:'',
        HanderName: [],//经办人
        HeaderName: [],//负责人
        comCode: "",
        record:'',
        result:'',
        checkState:false,
        appovelConfig:[],
        ApprConfigSort:'',
        userList:[],
        loading:false,
    }
    componentDidMount(){
        _FeedBackDawer = this
        this.getUser()
    }
      //经办人模糊匹配
      Jfetch(value, callback) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        function fake() {
            $.ajax({
                url: Hcurl + "/Business/GetAllComCodePhone?ComCode=" + _FeedBackDawer.state.record.CI_DealDeapartCode + "&UserName=" + value,
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    if (data != []) {
                        callback(data);
                    } else {
                        let data = []
                        callback(data);
                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                }
            })
        }
        timeout = setTimeout(fake, 300);
    }
     //负责人模糊匹配
     fetch(value, callback) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        function fake() {
            $.ajax({
                url: Hcurl + "/Business/GetAllComCodePhone?ComCode=" + _FeedBackDawer.state.record.CI_DealDeapartCode + "&UserName=" + value,
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    if (data != []) {
                        callback(data);
                    } else {
                        let data = []
                        callback(data);
                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                }
            })
        }
        timeout = setTimeout(fake, 300);
    }
      // 负责人模糊匹配下拉框方法
      HeaderNameChange(value) {
        _FeedBackDawer.props.form.setFieldsValue({
            responsibler: value!=undefined? value.replace(/'/g,''):''
        })
        if (value != undefined) {
            _FeedBackDawer.fetch(value, data => _FeedBackDawer.setState({ HeaderName: data }));
        }
    }
    // 负责人模糊匹配下拉框方法
    onHeaderName = (value, option) => {
        setTimeout(function () {
            _FeedBackDawer.props.form.setFieldsValue({
                responsiblerPhone: option.key
            })
        }, 20)
    }
      // 经办人模糊匹配下拉框方法
    HanderNameChange(value) {
        _FeedBackDawer.props.form.setFieldsValue({
            handler:value!=undefined? value.replace(/'/g,''):''
        })
        if (value != undefined) {
            _FeedBackDawer.Jfetch(value, data => _FeedBackDawer.setState({ HanderName: data }));
        }
    }
    HanderNameSelect = (value, option) => {
        setTimeout(function () {
            _FeedBackDawer.props.form.setFieldsValue({
                handlerPhone: option.key
            })
        }, 20)
    }
    onClose = ()=>{
        this.setState({
            visible:false,
            checkedState:true,
            fileList:[]
        })
        this.props.form.resetFields()
    }
    changeBox=()=>{
        if(this.state.showBox){
            this.setState({
                showBox:false
            })
        }else{
            this.setState({
                showBox:true
            })
        }
    }
    handleChange = (info) => {  //文件上传方法
        let fileList = info.fileList;
        if (info.file.status != "error") {
            
            if (info.file.status == "done") {
                message.success(`${info.file.name} 文件上传成功`);
                this.setState({
                    loading:false
                })
            } else {
                if (info.file.status == "removed") {
                    message.success(`${info.file.name} 文件移除成功`);
                    this.setState({
                        loading:false
                    })
                }
            }
            fileList = fileList.map((file) => {
                if (file.response) {
                    file.url = file.response;
                }
                return file;
            });

            if (info.file.size < 20971520 || info.file.size == null) {
                filePath = fileList;
                _FeedBackDawer.setState({ fileList: filePath });
            } else {
                filePath = _FeedBackDawer.state.fileList
                _FeedBackDawer.setState({ fileList: filePath });
            }

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 文件上传失败`);
            this.setState({
                loading:false
            })
        }

    }
    //上传前置事件
    beforeUpload = (file) => {
        this.setState({
            loading:true
        })
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isLt2M) {
            message.error('单个附件大小最多20M');
            return false
        }else {
            this.setState({ dataName: file.name })
        }
        return true;
    }
    //短信开关
    changeSwitch=(e)=>{
        this.setState({
            checkedState:e
        })
    }
    //弹出人员选择
    showChangePerson=()=>{

    }
    handleChangeAccept=()=>{

    }
    changeResult=(e)=>{
        this.setState({
            resultValue:e
        })
        var code = this.state.result.CI_Code
        var depatName = this.state.result.DealDeptName
        var text = ''
        let textTC = '您好，您登记'+code+'的的投诉，'+depatName+'依据情况已与您达成和解，详细情况可以登录"智慧315平台"进行查询。'
        let textTS = '您好，您登记的'+code+'的投诉现和解失败，详细情况可以登录"智慧315平台"进行查询。'
        let textWC = '您好，您登记的无理由退货工单（编号：'+code+'），'+depatName+'依据情况已与您达成和解，详细情况可以前往“江苏省消保委公众号”查看。'
        let textWS = '您好，您登记的无理由退货工单（编号：'+code+'）和解失败，您可以前往江苏省智慧315平台查看详细情况http://180.101.234.99:10001/customer/#/home。若您对处理结果有异议，请转至12315进行投诉。'
        if(e=='和解成功'&&this.state.result.CI_Type=='投诉'){
            text = textTC
        }else if(e=='和解成功'&&this.state.result.CI_Type!='投诉'){
            text = textWC
        }else if(e=='和解失败'&&this.state.result.CI_Type=='投诉'){
            text = textTS
        }else if(e=='和解失败'&&this.state.result.CI_Type!='投诉'){
            text = textWS
        }
        this.props.form.setFieldsValue({
            'messageContent':text
        })
        if(!this.state.checkState){
            this.getAppovel()
        }
    }
    changeRefund=(e)=>{
        this.setState({
            paymentMoney:e
        })
        
    }
    changeRadio=(e)=>{
        let _this = this
        this.props.form.setFieldsValue({
            'advancePayment':e.target.value
        })
        if(e.target.value==1){
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    'paymentMoney':_this.props.form.getFieldValue('refundMoney')
                })
           
            }, 200);
        
        }
        if(!this.state.checkState){
            this.getAppovel()
        }
        
    }
    changeSend=(e)=>{
        if(e.target.value==1){
        
            if(this.state.appovelConfig.length>0){
                setTimeout(() => {
                    _FeedBackDawer.props.form.setFieldsValue({
                        changePerson: _FeedBackDawer.state.appovelConfig[0].CheckUserListCode
                        })
                }, 100);
            }
        }
    }
    getUser(){
        $.ajax({
            url: Hcurl + '/Business/SearchUser',
            type: "get",
             headers: {
                 "token": EventSet.getUserInfo()['token']
             },
            data: {
                uCodes: '',
                userName:'',
            },
            success: function (data) {
               _FeedBackDawer.setState({
                    userList:data
               })
               
            },
            // error: function (data) {
            //     history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            // }
        })
    }
    feedBack=()=>{
        const { form } = this.props;
        form.validateFields((err, fieldsValue) => {
            if (err) {
                message.warning('请检查后重新尝试')
                return;
            }
            let imageUrl = '';
            $.each(this.state.fileList, function (ids, txt) {
                if (typeof (txt.url) != 'undefined' && txt.url != 'undefined')
                    imageUrl += txt.url + ';';
            })
            imageUrl = imageUrl.substring(0, imageUrl.length - 1);
            const { ...values } = fieldsValue;
            $.ajax({
                url: Hcurl + '/Business/BusinessPending',
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                data: {
                    CI_Code: _FeedBackDawer.state.result.CI_Code,
                    ModuleId: "",//传空
                    UserCode: EventSet.getUserInfo().CU_Code,
                    // CI_DealDeapartCode:_FeedBackDawer.state.result.CI_DealDeapartCode,//企业的直属部门
                    UserIp: localStorage.getItem('userIp'),
                    UserName: EventSet.getUserInfo().userName,
                    CP_Result: values.CP_Result,
                    CP_Attachs: imageUrl,
                    CP_Content: values.CP_Content,
                    CP_HanderName: values.handler,
                    CP_HanderPhone: values.handlerPhone,
                    CP_HeaderName: values.responsibler,
                    CP_HeaderPhone: values.responsiblerPhone,
                    Com_Code:_FeedBackDawer.state.result.CI_DealDeapartCode,
                    ApplyMediation: "",//是否申请调解传空
                    CP_RedeemLoss: values.refundMoney,
                    CP_DisputeMoney: values.disputeMoney,
                    CP_IsPay:values.advancePayment,
                    CP_PayAmount:values.paymentMoney,
                    IsSendMsg:_FeedBackDawer.state.checkedState?'1':'0',
                    SendMsgContent:values.messageContent!=undefined?values.messageContent.replace(/\n/g,''):'',
                    Comment:values.Postscript,
                    IsNeedAppove:values.isSend!=undefined?values.isSend:'',
                    AppoveConfigID:_FeedBackDawer.state.appovelConfig.length>0?_FeedBackDawer.state.appovelConfig[0].ID:'',
                    AppoveSort:_FeedBackDawer.state.appovelConfig.length>0?_FeedBackDawer.state.appovelConfig[0].ApprConfigSort:'',
                    RoleCode:_FeedBackDawer.state.appovelConfig.length>0?_FeedBackDawer.state.appovelConfig[0].RoleCode:'',
                    AppoveUserList:values.changePerson!=undefined?(Array.isArray(values.changePerson)?values.changePerson.join(";"):values.changePerson):'',
                },
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    if (data.indexOf('|') >= 0) {
                        if (data.split('|')[0] == "true") {
                         
                            message.success(data.split('|')[1]);
                         
                            _FeedBackDawer.setState({
                                visible:false,
                                checkedState:true,
                            })
                            _FeedBackDawer.props.form.resetFields()
                            setTimeout(() => {
                                _companyList.tableData();
                            }, 200)
                        } else {
                            message.warn(data.split('|')[1]);

                        }

                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                }
            })
        })
    }
    onReloadAttachs(files) {
        if (files != null && files != '') {
            const attachfiles = files.split(';');
            return (attachfiles.map(function (item, index) {
                return <a key={index} href={item} target='_blank' style={{ display: item.toString() == '' ? 'none' : 'inline' }} > 附件{index + 1}</a >
            }))
        }
    }
    onRenderContent(content) {
        try {
            if (content.indexOf('￥') >= 0 && content.indexOf('$') >= 0 && content.indexOf('￡') >= 0) {
                var str1 = content.substring(content.indexOf("￥") + 1, content.lastIndexOf("￥"));//平台账号
                var str2 = content.substring(content.indexOf("$") + 1, content.lastIndexOf("$"));//订单编号
                var str3 = content.substring(content.indexOf("￡") + 1, content.lastIndexOf("￡"));//投诉内容
                return <span><span>平台账号:{str1}</span><br /><span>订单编号:{str2}</span><br /><span>{str3}</span></span>
            }
            else return content;
        } catch (e) { return content; }
    }
       //点击显示登记编号弹框
    ModalCase = (record) => {
        //this.setState({
        //    visible: true,
        //    _record: record
        //})
        _companyList.props.dispatch(evn.showCaseInfo(record.ID, 'CompanyCase'))
    }
    myValidator1 = (rule, value, callback) => {
        if (value != undefined) {
            if (value.length > 20) {
                callback('20个字以内');
                return;
            } else {
                callback();
            }
        } else {
            callback();
        }
    }
    myValidator2 = (rule, value, callback) => {
        if (value != undefined) {
            if (value.length > 20) {
                callback('20个字以内');
                return;
            } else {
                callback();
            }
        } else {
            callback();
        }
    }
    getAppovel(){
        var paymentMoney = _FeedBackDawer.props.form.getFieldValue('paymentMoney')
        // if(paymentMoney){
        //     paymentMoney = paymentMoney.toString()
        // }
        $.ajax({
            url: Hcurl + '/Business/GetCaseFeedApproveConfig',
            type: "get",
             headers: {
                 "token": EventSet.getUserInfo()['token']
             },
            data: {
                comCode: JSON.parse(localStorage.getItem("userInfo")).xxhjcompanycode,
                isPay:_FeedBackDawer.props.form.getFieldValue('advancePayment')!=undefined?_FeedBackDawer.props.form.getFieldValue('advancePayment'):'',
                payAmount:_FeedBackDawer.props.form.getFieldValue('paymentMoney')!=undefined?_FeedBackDawer.props.form.getFieldValue('paymentMoney'):'',
            },
            success: function (data) {
               _FeedBackDawer.setState({
                    appovelConfig:data
               })
               if(data.length>0){
                   setTimeout(() => {
                    _FeedBackDawer.props.form.setFieldsValue({
                        changePerson: data[0].CheckUserListCode.split(';')
                        })
                   }, 100);
                
               }
               
               
            },
            // error: function (data) {
            //     history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            // }
        })
    }
    changePaymonetMoney=(e)=>{
        if(!this.state.checkState){
            this.getAppovel()
        }
    }
    myValidatorS = (rule, value, callback) => {
        if (value != undefined && value != '') {
            if (value.length > 20) {
                callback('审批人不能超过20位');
            } else {
                callback()
            }
        } else {
            callback('请选择审批人');
        }
    }
    render(){
        const { getFieldDecorator } = this.props.form;
        const head = { 'X-Requested-With': null }
        const cusSymbol = '￥'
        const reg = new RegExp(`${cusSymbol}\\s?|(,*)`,'g')
        return (
            <div>
                 <Drawer
          title="反馈"
          placement="right"
          onClose={this.onClose}
          visible={this.state.visible}
          width={800}
        >
            <div className="detailTop" >
                <div className="leftIcon" onClick={this.changeBox}><Icon type={this.state.showBox?'down':'up'} /><span style={{marginLeft:'10px'}}>简要信息</span></div>
                <div className="detailText" onClick={()=>this.ModalCase(this.state.result)}>详细信息>></div>
            </div>
            {this.state.showBox?<div className="DeBox"><Descriptions  bordered size={"small"}>
                <Descriptions.Item label="工单编号" >{this.state.result.CI_Code}</Descriptions.Item>
                <Descriptions.Item label="登记部门" span={2}>{this.state.result.Dept_Name}</Descriptions.Item>
                <Descriptions.Item label="登记时间" >{(this.state.result.CI_RegTime!=''&&this.state.result.CI_RegTime!=null)?this.state.result.CI_RegTime.substring(0,16):''} </Descriptions.Item>
                <Descriptions.Item label="投诉时间" span={2}>{(this.state.result.CI_TypeTime!=''&&this.state.result.CI_TypeTime!=null)?this.state.result.CI_TypeTime.substring(0,16):''}</Descriptions.Item>
                <Descriptions.Item label="受理期限" >{this.state.result.ReceiveEndDate}</Descriptions.Item>
                <Descriptions.Item label="办理期限" span={2}>{this.state.result.RealEndDate}</Descriptions.Item>
                <Descriptions.Item label="信息提示" span={3}>{this.state.record.AF_CasePress_count!= 0 ?
                            <Tooltip title={this.state.record.AF_CasePress} arrowPointAtCenter={true} placement="top">
                                <img src={cuiBan} style={{ width: '16px' }} />
                            </Tooltip> : ""}</Descriptions.Item>
                <Descriptions.Item label="提供方名称" ><span className="pubBox" title={this.state.result.CI_UserName}>{this.state.result.CI_UserName}</span> </Descriptions.Item>
                <Descriptions.Item label="提供方电话" span={2}>{this.state.result.CI_UserPhone}</Descriptions.Item>
                <Descriptions.Item label="客体类型" span={3}><span className="pubLarge">{this.state.result.ShopType} </span></Descriptions.Item>
                <Descriptions.Item label="商品/服务名称" ><span className="pubBox"  title={this.state.result.CI_ShopName}>{this.state.result.CI_ShopName}</span> </Descriptions.Item>
                <Descriptions.Item label="品牌/商标名称" span={2}><span className="pubBox" title={this.state.result.CI_ShopBrandName}>{this.state.result.CI_ShopBrandName}</span></Descriptions.Item>
                <Descriptions.Item label="销售方式" >{this.state.result.CI_SellMethod} </Descriptions.Item>
                <Descriptions.Item label="事发时间" span={2}>{this.state.result.CI_EventTime}</Descriptions.Item>
                <Descriptions.Item label={this.state.result.CI_SellMethod!='网络购物'?'事发地址':'订单号'} span={3}><span className="pubLarge">{this.state.result.CI_SellMethod!='网络购物'?this.state.result.EventAreaName:this.state.result.CI_OrderID} </span></Descriptions.Item>
                <Descriptions.Item label="诉求" span={3}><span className="pubLarge">{this.state.result.CI_BriefInfo} </span></Descriptions.Item>
                <Descriptions.Item label="投诉内容" span={3}><span className="pubLarge">{this.onRenderContent(this.state.result.CI_Content)} </span></Descriptions.Item>
                <Descriptions.Item label="附件" span={3}>{this.onReloadAttachs(this.state.result.CI_Attachs)} </Descriptions.Item>
            </Descriptions></div>:''}
            <Form  className='formSearch' style={{ marginLeft: 10,paddingBottom:'80px' }}>
                        <p className="textBold">和解反馈</p>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem
                                    label="和解结果"
                                >
                                    {getFieldDecorator('CP_Result' ,{
                                        initialValue:'和解成功',
                                    rules: [
                                        { required: true, message: '请选择和解结果' },
                                    ],
                                })(
                                            <Select placeholder='请选择和解结果' onChange={this.changeResult}>
                                                <Option value="和解成功">和解成功</Option>
                                                <Option value="和解失败">和解失败</Option>
                                            </Select>
                                    )}
                                </FormItem>
                            </Col>
                           

                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem
                                    label="争议金额"
                                >
                                    {getFieldDecorator('disputeMoney',{
                                    rules: [
                                        { required: true, message: '请输入争议金额' },
                                    ],
                                })(
                                    <InputNumber style={{width:'100%'}}
                                    formatter={value => `${cusSymbol} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(reg, '')}
                                    precision={2}
                                    max={ 999999999.99}
                                    min={0}
                                  />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    label="退赔金额"
                                >
                                    {getFieldDecorator('refundMoney',{
                                    rules: [
                                        { required: true, message: '请输入退赔金额' },
                                    ],
                                })(
                                    <InputNumber style={{width:'100%'}}
                                    formatter={value => `${cusSymbol} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(reg, '')}
                                    precision={2}
                                    max={ 999999999.99}
                                    min={0}
                                    onChange={this.changeRefund}
                                  />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem
                                    label="经办人"
                                >
                                    {getFieldDecorator('handler',{
                                    rules: [
                                        { required: true, message: '请输入经办人' },
                                         { validator: this.myValidator1 }
                                    ],
                                })(
                                    <Select
                                    allowClear
                                    mode="combobox"
                                    placeholder="请输入经办人姓名"
                                    defaultActiveFirstOption={false}
                                    showArrow={false}
                                    filterOption={false}
                                    onChange={this.HanderNameChange}
                                    onSelect={this.HanderNameSelect}
                                >
                                    {
                                        this.state.HanderName.map(function (e) {
                                            return <Option key={e.CU_LinkPhone} value={e.CU_UserName}>{e.CU_UserName}</Option>
                                        })
                                    }
                                </Select>
                                
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    label="经办人电话"
                                >
                                    {getFieldDecorator('handlerPhone',{
                                    rules: [
                                        { required: true, message: '请输入经办人电话' },
                                        { pattern: /^\d{6,18}$/, message: '请输入有效的联系电话' }
                                    ],
                                })(
                                    <Input style={{width:'100%'}}/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem
                                    label="负责人"
                                >
                                    {getFieldDecorator('responsibler',{
                                    rules: [
                                        { required: true, message: '请输入负责人' },
                                        { validator: this.myValidator2 }
                                    ],
                                })(
                                    <Select
                                    allowClear
                                    mode="combobox"
                                    placeholder="请输入负责人姓名"
                                    defaultActiveFirstOption={false}
                                    showArrow={false}
                                    filterOption={false}
                                    onChange={this.HeaderNameChange}
                                    onSelect={this.onHeaderName}

                                >
                                    {
                                        this.state.HeaderName.map(function (e) {
                                            return <Option key={e.CU_LinkPhone} value={e.CU_UserName}>{e.CU_UserName}</Option>
                                        })
                                    }
                                </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    label="负责人电话"
                                >
                                    {getFieldDecorator('responsiblerPhone',{
                                    rules: [
                                        { required: true, message: '请输入负责人电话' },
                                        { pattern: /^\d{6,18}$/, message: '请输入有效的联系电话' }
                                    ],
                                })(
                                    <Input style={{width:'100%'}}/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={24}>
                                <FormItem
                                    label="详细说明"
                                >
                                    {getFieldDecorator('CP_Content',{
                                    rules: [
                                        { required: true, message: '请输入详细说明' },
                                    ],
                                })(
                                    <TextArea rows={4} maxLength={1000}  placeholder="请输入和解的详细办理情况。"/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24}>
                        <Col span={8}>
                                    <FormItem
                                        label=""
                                    >
                                        {getFieldDecorator('CP_Attach', {
                                            rules: [{ required: false, message: '请输入办理内容' }],
                                        }
                                        )(
                                         <Upload
                                                name="file"
                                                // action="https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"
                                                action={"https://wisdom.jsca315.org.cn/wisdom315_BusinessAPI_jiangsu/api/HomePage/Uploadfile"}
                                                onChange={this.handleChange}
                                                beforeUpload={this.beforeUpload}
                                                fileList={this.state.fileList}
                                                headers={head}
                                              
                                            ><Button disabled={ this.state.fileList.length >= 4?true:false}>
                                                    <Icon type="upload" /> 附件上传
                                            </Button> 
                                </Upload> )}
                                    </FormItem>
                                </Col>
                        </Row>
                        {(this.state.resultValue=='和解成功'&& this.state.result.CI_Type!='投诉')?<div>
                        <p className="textBold">垫付信息</p>
                        <Row gutter={24}>
                            <Col span={24}>
                                <FormItem
                                    label="申请先行垫付"
                                >
                                    {getFieldDecorator('advancePayment',{
                                        initialValue:0,
                                    rules: [
                                        { required: true, message: '请选择先行垫付' },
                                    ],
                                })(
                                    <Radio.Group  onChange={this.changeRadio} disabled={this.state.checkState}>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                  </Radio.Group>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        {this.props.form.getFieldValue('advancePayment')==1?<Row gutter={24}>
                            <Col span={12}>
                                <FormItem
                                    label="垫付金额"
                                >
                                     {getFieldDecorator('paymentMoney',{
                                    rules: [
                                        { required: true, message: '请输入垫付金额' },
                                    ],
                                })(
                                    <InputNumber style={{width:'100%'}}
                                    formatter={value => `${cusSymbol} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(reg, '')}
                                    precision={2}
                                    max={999999999999.99}
                                    min={-999999999999.99}
                                    onChange={this.changePaymonetMoney}
                                    maxLength={20}
                                  />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>:''}
                        
                        {this.props.form.getFieldValue('advancePayment')==1?<Row gutter={24}>
                            <Col span={24}>
                                <FormItem
                                    label="附言"
                                >
                                     {getFieldDecorator('Postscript',{
                                    rules: [
                                        { required: false, message: '请输入附言' },
                                    ],
                                })(
                                    <TextArea rows={4} maxLength={400} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>:''}
                        </div>:''}
                        <p className="textBold">短信回复</p>
                        <Row gutter={24}>
                            <Col span={24}>
                                <FormItem
                                    label="短信通知"
                                >
                                     {getFieldDecorator('notice',{
                                         initialValue:true,
                                    rules: [
                                        { required: true, message: '请选择短信通知' },
                                    ],
                                })(
                                    <Switch checkedChildren="开" unCheckedChildren="关" onChange={this.changeSwitch} checked={this.state.checkedState}  />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row gutter={24} style={{display:this.state.checkedState?'block':'none'}}>
                            <Col span={24}>
                                <FormItem
                                    label="短信内容"
                                >
                                     {getFieldDecorator('messageContent',{
                                    rules: [
                                        { required: true, message: '请输入短信内容' },
                                    ],
                                })(
                                    <TextArea rows={4} maxLength={120} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        {(this.state.resultValue=='和解成功'&& this.state.result.CI_Type!='投诉'&&this.props.form.getFieldValue('advancePayment')==1)?<div>
                        <p className="textBold">送审信息</p>
                        <Row gutter={24}>
                            <Col span={24}>
                                <FormItem
                                    label="是否送审"
                                >
                                    {getFieldDecorator('isSend',{
                                    initialValue:1,
                                    rules: [
                                        { required: true, message: '请选择是否送审' },
                                    ],
                                })(
                                    <Radio.Group disabled={this.state.ApprConfigSort!='1'} onChange={this.changeSend}>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                  </Radio.Group>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        {this.props.form.getFieldValue('isSend')==1?<Row gutter={24}>
                            <Col span={24}>
                             <FormItem
                                        label='审批人'
                                    >
                                        {getFieldDecorator('changePerson', {
                                            rules: [{ required: true, validator: this.myValidatorS }],
                                        })(
                                            <Select disabled={this.state.ApprConfigSort!='1'} className="rightBorder"  mode="multiple" onChange={this.handleChangeAccept}  optionFilterProp="label" style={{ borderRadius: '4px 0 0 4px', width: '96%' }}>
                                                {this.state.userList.map((item)=>{
                                                   return <Option key={item.U_Code} label={item.UserName.split('(')[0]} value={item.U_Code}>{item.UserName}</Option>
                                                })}
                                            </Select>

                                        )}
                                        <div style={{ width: '32px', height: '32px', position: 'absolute', top: '-6px', right: '-31px', borderRadius: '0 4px 4px 0', border: '1px solid #d9d9d9', background: '#fafafa', lineHeight: '32px', textAlign: 'center' }}><Icon type="plus" onClick={() =>this.showChangePerson('changePerson')} /></div>

                            </FormItem>
                            </Col>
                        </Row>:''}
                        {this.props.form.getFieldValue('isSend')==1?<Row gutter={24}>
                            <Col span={24}>
                                <FormItem
                                    label="附言"
                                >
                                     {getFieldDecorator('sendPostscript',{
                                    rules: [
                                        { required: false, message: '请输入附言' },
                                    ],
                                })(
                                    <TextArea rows={4} maxLength={400} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>:''}</div>:''}
                        


            </Form>

          <div style={{position:"absolute",right:'0',bottom:'0',height:'50px',width:'100%',padding:'0 24px',lineHeight:'50px',borderTop:'1px solid #f2f2f2',background:"#fff"}}>
              <Button onClick={this.feedBack} loading={this.state.loading} style={{float:'right',marginTop:'10px'}} type="primary">提交</Button>
              <Button onClick={this.onClose} style={{float:'right',marginRight:'8px',marginTop:'10px'}}>取消</Button>
              
          </div>
        </Drawer>
            </div>
        )
    }
}
const FeedBackDawerWrapper = Form.create()(FeedBackDawer);
//选择企业弹框

let _CompanyModalList = null;
let companyCode = '';
class CompanyModalList extends React.Component {
    state = {
        visible: false,
        selectedRowKeys: [],
        loading: false,
        data: [],
        value: [],
        allChecked: false,
        dataCheck: [],//企业多选框
        saveValue: [],
        disabled: true
    }
    componentDidMount() {
        _CompanyModalList = this;


    }

    isInArray = (arr, value) => {
        var arrary = [];
        for (var i = 0; i < arr.length; i++) {
            if (value.indexOf(arr[i].Com_CodeAndName) < 0) {
                arrary.push(arr[i].Com_CodeAndName);
            } else {
            }
        }
        this.setState({
            value: arrary
        })
    }

    handleOk = () => {  //弹框确定
        this.setState({
            loading: true,
            visible: false,
        })
        this.setState({
            saveValue: this.state.value
        })
        setTimeout(() => {
            let stateValue = this.state.saveValue;
            if (this.state.value.length != 0) {
                let companyName = '';

                for (var i = 0; i < stateValue.length; i++) {
                    companyName += stateValue[i].split(',')[1] + ' ; '
                    companyCode += stateValue[i].split(',')[0] + ','
                }
                companyCode = companyCode.substring(0, companyCode.length - 1);

                companyName = companyName.substring(0, companyName.length - 2);
                _companyList.setState({
                    companyAllList: companyName,
                    companyList: 1,
                    span: 22,
                })

            } else {
                _companyList.GetSelectCompany(); //获取所有企业
                this.setState({
                    value: []
                })
                _companyList.setState({
                    companyList: 0,
                    span: 24
                })
            }
            _CompanyModalList.UserDefaultCompanys();
            //_companyList.tableData()
        }, 20)

        setTimeout(() => {
            _CompanyModalList.setState({
                loading: false
            })
        }, 200)
        companyCode = "";
    }
    handleCancel = () => {
        this.setState({
            visible: false
        })
    }
    //设置用户选择的企业
    UserDefaultCompanys = () => {
        $.ajax({
            url: Hcurl + "/Business/SetUserDefaultCompanys?CU_Code=" + EventSet.getUserInfo().CU_Code + "&CU_ComCode=" + companyCode + '&Type=' + 1,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                if (data == 'True') {
                    _companyList.tableData()
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })

    }

    onChange = (value) => {  //点击单个多选框方法
        if (value.length === 0) {
            this.setState({
                disabled: true
            })
        } else {
            this.setState({
                disabled: false
            })
        }
        this.setState({
            value,
            //allChecked: value.length === data.length
        });
    }
    handleCheckAll = (e) => {  //全选

        const checked = e.target.checked
        this.setState({ allChecked: checked })
        if (checked) {
            this.setState({
                value: this.state.dataCheck.map(item => item.Com_CodeAndName),
                disabled: false
            })
            //companyCode = this.state.dataCheck.map(item => item.Com_Code)
        }
    }
    handleCheckAll2 = (e) => {  //反选
        this.setState({ allChecked: false })
        if (this.state.value.length !== 0) {
            if (this.state.value.length == this.state.dataCheck.length) {
                this.setState({ value: [] });
            } else {
                this.isInArray(this.state.dataCheck, this.state.value)
            }
        }
        setTimeout(() => {
            if (_CompanyModalList.state.value.length === 0) {
                _CompanyModalList.setState({
                    disabled: true
                })
            } else {
                _CompanyModalList.setState({
                    disabled: false
                })
            }
        }, 20)

    }

    render() {
        return (
            <div style={{ width: 1000 }}>
                <Modal
                    title="选择企业"
                    width={600}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    loading={this.state.loading}
                    maskClosable={false}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loading} onClick={this.handleOk}>
                            确定
                        </Button>,
                    ]}
                >
                    <div className='LModalList' id='LocaleProvider'>
                        <div style={{ marginBottom: 10 }}>请选择下方企业条目</div>
                        <Checkbox onChange={this.handleCheckAll} checked={this.state.allChecked} style={{ marginRight: 10 }}>全选</Checkbox>
                        <Checkbox onChange={this.handleCheckAll2} checked={this.state.allChecked} disabled={this.state.disabled}>反选</Checkbox>
                        <div className='LCheckbox2 LCheckbox'>
                            <Checkbox.Group onChange={this.onChange} value={this.state.value}>
                                {
                                    this.state.dataCheck.map(item => <div key={item.Com_Code} className='div'>
                                        <Checkbox value={item.Com_CodeAndName} style={{ width: '100%' }} className='Lli' id={item.Com_Code}>{(item.Com_Name).length >= 26 ? (item.Com_Name).substring(0, 26) + '...' : item.Com_Name}<span style={{ float: "right", color: "#169BD5" }}>{item.Count}条待和解</span></Checkbox>
                                    </div>)
                                }
                            </Checkbox.Group>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

////退回
var _ReturnBack = null;
class ReturnBack extends React.Component {
    state = {
        visible: false,
        IId: null,
        value: ""
    }
    showModal = () => {
        this.setState({
            visible: true,
        });
    }
    handleOk = (e) => {
        const { form } = this.props;
        form.validateFields((err, fieldsValue) => {
            if (err) {
                message.warn('请检查后重新尝试')
                return;
            };
            const values = {
                ...fieldsValue,
            };
            $.ajax({
                url: Hcurl + '/Business/ReturnBusiness',
                type: "post",
                                            headers: {
                                                "token": EventSet.getUserInfo()['token']
                                            },
                data: {
                    code: _thisRecord.CI_Code,
                    JoinMan: EventSet.getUserInfo().userName,
                    CR_Reason: values.content,
                    UserCode: EventSet.getUserInfo().CU_Code,
                    UserComCode: _thisRecord.CI_DealDeapartCode,
                    IsJuJue: false,
                },
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    const pagination = { ..._this.state.pagination };
                    pagination.current = 1;
                    _this.setState({
                        pagination: pagination
                    })
                    if (data.indexOf('|') >= 0) {
                        if (data.split('|')[0] == "true") {
                            message.success(data.split('|')[1]);
                            _ReturnBack.setState({
                                visible: false
                            })
                            setTimeout(function () {
                                _companyList.tableData()
                            }, 20)
                        } else {
                            message.warn(data.split('|')[1]);
                            _ReturnBack.setState({
                                visible: false
                            })
                            setTimeout(function () {
                                _companyList.tableData()
                            }, 20)
                        }

                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                }
            })
        })
    }
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }
    componentDidMount() {
        _ReturnBack = this;
    }

    render() {
        const { visible } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Modal 
                    title='退回'
                    visible={visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                >
                    <Row>
                        <Form onSubmit={this.handleOk} style={{ marginTop: '20px', marginBottom: '20px', height: 150 }}>
                            <FormItem
                                label="退回原因"
                                labelCol={{ span: 5 }}
                                wrapperCol={{ span: 18 }}
                            >
                                {getFieldDecorator('content', {
                                    rules: [
                                        { required: true, message: '请输入退回原因' },
                                    ],
                                }
                                )(
                                    <TextArea autosize={{ minRows: 6, maxRows: 10 }} size='small' placeholder='请输入退回原因，400字内' maxLength={400} />
                                    )}
                            </FormItem>
                        </Form>
                    </Row>
                </Modal>
            </div>
        );
    }
}
const ReturnBackWrapper = Form.create()(ReturnBack);


////拒绝和解
var _RefuseBack = null;
let _record = null;
class RefuseBack extends React.Component {
    state = {
        visible: false,
        value: ""
    }
    showModal = () => {
        this.setState({
            visible: true,
        });
    }
    handleOk = (e) => {
        e.preventDefault();
        const { form } = this.props;
        form.validateFields((err, fieldsValue) => {
            if (err) {
                message.warn('请检查后重新尝试')
                return;
            };
            const values = {
                ...fieldsValue,
            };
            $.ajax({
                url: Hcurl + '/Business/RefuzeCaseByCode',
                type: "post",
                headers: {
                    "token": JSON.parse(localStorage.getItem('userInfo')).token
                },
                data: {
                    CI_Type:_record.CI_Type,
                    code: _record.CI_Code,
                    ID: _record.ID,
                    JoinMan: JSON.parse(localStorage.getItem('userInfo')).userName,
                    CR_Reason: values.content,
                    UserCode: EventSet.getUserInfo().CU_Code,
                    UserComCode: _record.CI_DealDeapartCode,
                },
                success: function (data) {
                    if (data.indexOf('|') >= 0) {
                        if (data.split('|')[0] == "true") {
                            message.success(data.split('|')[1]);
                            // $.ajax({
                            //     url: data_Url + 'WisdomAPI.ashx',
                            //     //url: "http://localhost:5113/ashx/WisdomAPI.ashx",
                            //     headers: {
                            //         "token": EventSet.getUserInfo()['token']
                            //     },
                            //     dataType: "jsonp",
                            //     jsonp: "callback",
                            //     jsonpCallback: "successcallback",
                            //     data: {
                            //         doType: "SendTemplateMessage",
                            //         CIID: _record.ID,
                            //         tele: _record.CI_UserPhone,
                            //         msg: _record.CI_Code + ";" + _record.Com_Name,
                            //         templateCode: "20171202023",
                            //         isPostWxMessage: 1,
                            //         UserName: EventSet.getUserInfo().userName,
                            //         UserCode: EventSet.getUserInfo().CU_Code,
                            //         IP: localStorage.getItem('userIp'),
                            //         userType: 2,//企业传2，部门传1
                            //     },
                            //     success: function (data) {
                            //     },
                            //     error: function (data) {
                            //     }
                            // })

                            _RefuseBack.setState({
                                visible: false
                            })
                            setTimeout(function () {
                                _companyList.tableData()
                            }, 20)
                        } else {
                            message.warn(data.split('|')[1]);
                            _RefuseBack.setState({
                                visible: false
                            })
                            //setTimeout(function () {
                            //    _companyList.tableData()
                            //}, 20)
                        }

                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                }
            })

        })
    }
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }
    componentDidMount() {
        _RefuseBack = this;
    }

    render() {
        const { visible } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Modal
                    title='拒绝和解'
                    visible={visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                >
                    <Row>
                        <Form onSubmit={this.handleOk} style={{ marginTop: '20px', marginBottom: '20px', height: 150 }}>
                            <FormItem
                                label="拒绝原因"
                                labelCol={{span:4}}
                                wrapperCol={{ span: 20 }}
                            >
                                {getFieldDecorator('content', {
                                    rules: [
                                        { required: true, message: '请输入拒绝原因' },
                                    ],
                                }
                                )(
                                    <TextArea autosize={{ minRows: 8, maxRows: 12 }} size='small' placeholder='请输入拒绝原因，400字内，必填' maxLength={400} />
                                    )}
                            </FormItem>
                        </Form>
                    </Row>
                </Modal>
            </div>
        );
    }
}
const RefuseBackWrapper = Form.create()(RefuseBack);




//表格
var _this = this;
var _thisRecord = this;
class TableWaper extends Component {
    componentDidMount() {
        _this = this;
    }
    componentWillMount(){
        _this = this;
    }
    state = {
        data: [], //数据源
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0
        },
        loading: false,
        pagetotalCount: 0,
        display: 'none',
        _record: "",
        sorters: 'CI_ComReceiveTime desc'
    }
    

    handleTableChange = (pagination, filters, sorter) => {
        this.setState({
            pagination: pagination,
        });
        if (Object.keys(sorter).length !== 0) {
            if (sorter.field == "CI_ComReceiveTime" && sorter.order!=undefined) {
                _this.setState({
                    sorters: sorter.order == 'descend' ? "CI_ComReceiveTime desc" : "CI_ComReceiveTime"
                })
            }else if(sorter.field == "CI_ComReceiveTime" && sorter.order==undefined){
                _this.setState({
                    sorters:  "CI_ComReceiveTime desc" 
                })
            }
            if (sorter.field == "CI_DealEndDate"&& sorter.order!=undefined ) {
                _this.setState({
                    sorters: sorter.order == 'descend' ? "CI_DealEndDate desc" : "CI_DealEndDate"
                })
            }else if(sorter.field == "CI_DealEndDate"&& sorter.order==undefined){
                _this.setState({
                    sorters:  "CI_ComReceiveTime desc" 
                })
            }

        }
        setTimeout(function () {
            _companyList.tableData()
        }, 20)
    };
    componentDidMount() {
        _this = this;
    }
    onReturnBack = (record) => {  //退回
        _thisRecord = record;
        _ReturnBack.setState({
            visible: true
        })
        _ReturnBack.props.form.setFieldsValue({
            content: ""
        })
    }

    onEditClick = (record) => {  //确认接收

        if (record.isReceive == "1") {
            confirm({
                title: '确认接收',
                content: '确定接收当前业务单吗？',
                okText:'确定',
                cancelText:'取消',
                onOk() {
                    $.ajax({
                        url: Hcurl + '/Business/ConfirmReceive',
                        type: "post",
                        data: {
                            Code: record.CI_Code,
                            ModuleID: "",//传空
                            UserCode: EventSet.getUserInfo().CU_Code,//当前登录人Code
                            CI_DealDeapartCode: record.CI_DealDeapartCode,//企业Code
                            UserIp: "",//传空
                            JoinMan: EventSet.getUserInfo().userName,//当前登录人名称
                            CP_Result: "",//传空
                        },
                        headers: {
                            "token": EventSet.getUserInfo()['token']
                        },
                        success: function (data) {
                            if (data.indexOf('|') >= 0) {
                                if (data.split('|')[0] == "true") {
                                    message.success(data.split('|')[1]);
                                    _companyList.tableData();
                                    //发送短信
                                    // $.ajax({
                                    //     url: data_Url + 'WisdomAPI.ashx',
                                    //     //url: "http://localhost:5113/ashx/WisdomAPI.ashx",
                                    //     type: "post",
                                    //         headers: {
                                    //             "token": EventSet.getUserInfo()['token']
                                    //         },
                                    //     dataType: "jsonp",
                                    //     jsonp: "callback",
                                    //     jsonpCallback: "successcallback",
                                    //     data: {
                                    //         doType: "SendTemplateMessage",
                                    //         CIID: record.ID,//3244,
                                    //         tele: record.CI_UserPhone,
                                    //         msg: "",
                                    //         templateCode: record.CI_Type=='投诉'?"20171202012":"20211106003",
                                    //         isPostWxMessage: 1,
                                    //         UserName: EventSet.getUserInfo().userName,
                                    //         UserCode: EventSet.getUserInfo().CU_Code,
                                    //         IP: localStorage.getItem('userIp'),
                                    //         userType: 2,//企业传2，部门传1
                                    //     },
                                    //     success: function (data) {
                                    //     },
                                    //     error: function (data) {
                                    //     }
                                    // })
                                } else {
                                    message.warn(data.split('|')[1])
                                }
                            }
                        },
                        error: function (data) {
                            history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                        }
                    })

                },
                onCancel() {

                }
            })
        } else {

            sessionStorage.setItem('record_'+record.CI_Code,JSON.stringify(record))
            // history.push({
            //     pathname: '/Content/Business/CompromiseListWait/CompormiseTransact?CI_Code=' + record.CI_Code + '&CI_DealDeapartCode=' + record.CI_DealDeapartCode + '&cid=' + record.ID,
            // })
            this.feedback(record)

        }
    }
    //拒绝和解
    onRefuse = (record) => {
        _record = record;
        _RefuseBack.setState({
            visible: true
        })
        _RefuseBack.props.form.setFieldsValue({
            content: ""
        })
    }
    recordCheck=(record)=>{
        $.ajax({
            url: Hcurl + '/Business/AddViewLog',
            type: "post",
            data: {
                CI_Code: record.CI_Code,
                UserCode: EventSet.getUserInfo().CU_Code,//当前登录人Code
                UserName: EventSet.getUserInfo().userName,//当前登录人名称
            },
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
              
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    //点击显示登记编号弹框
    ModalCase = (record) => {
        //this.setState({
        //    visible: true,
        //    _record: record
        //})
        this.recordCheck(record)
        _companyList.props.dispatch(evn.showCaseInfo(record.ID, 'CompanyCase'))
    }
    //点击关闭登记编号弹框
    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    }
    feedback=(record)=>{
        _FeedBackDawer.setState({
            visible:true,
            record:record,
            fileList:[]
        })
        var code = record.CI_Code
        var depatName = record.Com_Name
        var text = ''
        let textTC = '您好，您登记'+code+'的的投诉，'+depatName+'依据情况已与您达成和解，详细情况可以登录"智慧315平台"进行查询。'

        let textWC = '您好，您登记的无理由退货工单（编号：'+code+'），'+depatName+'依据情况已与您达成和解，详细情况可以前往“江苏省消保委公众号”查看。'
       
        if(record.CI_Type=='投诉'){
            text = textTC
        }else if(record.CI_Type!='投诉'){
            text = textWC
        }
       
        _FeedBackDawer.props.form.setFieldsValue({
            'messageContent':text
        })
        let t = JSON.parse(localStorage.userInfo)
        let token = t.token
        $.ajax({
            url: data_Url + 'WisdomAPI.ashx',
            type: "post",
            headers: {
                "token": token
            },
            dataType: "jsonp",
            jsonp: "callback",
            ansyc: false,
            cache: false,
            timeout: 360000,
            jsonpCallback: "successcallback",
            data: {
                doType: "GetCaseInfoDtsByID",
                ID: record.ID
            },
            success: function (result) {
                if (result != null && result != '') {
                    //result = JSON.parse(result);
                    _FeedBackDawer.setState({
                        result:result,
                    })
                }
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })

            }
        })

       this.getRole()
       this.getListInfo(record)
      
    }
    fileName(url, array) {
        url = url || "";
        let fileName = "";
        if (url) {
            array.forEach(keys => {
                if (url.indexOf(keys) > -1) {
                    fileName = url.substring(url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } })[url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } }).length - 1] + 1, url.indexOf(keys) - 1) + '.' + keys
                }
            })
        }
        return fileName;
    }
    getListInfo(record){
        let _this = this
        $.ajax({
            url: Hcurl + "/Business/GetBusinessPending?CI_Code=" + record.CI_Code,
            type: "post",
             headers: {
                 "token": EventSet.getUserInfo()['token']
             },
            success: function (data) {
                if(data.length>0){
                    _FeedBackDawer.props.form.setFieldsValue({
                        CP_Result: data[0].CP_Result,
                        disputeMoney:data[0].CP_DisputeMoney,
                        refundMoney:data[0].CP_RedeemLoss,
                        handler:data[0].CP_HanderName,
                        handlerPhone:data[0].CP_HanderPhone,
                        responsibler:data[0].CP_HeaderName,
                        responsiblerPhone:data[0].CP_HeaderPhone,
                        CP_Content:data[0].CP_Content,
                        advancePayment:data[0].CP_IsPay,
                        })

                        if (data[0].CP_Attachs !== "" && data[0].CP_Attachs != null) {
                            const allImage = data[0].CP_Attachs.split(";")
                            var arr = '{"filelist":[';
                            for (var i = 0; i < allImage.length; i++) {
                                
        
                                arr += '{"uid":"' + i + '","name":"' + _this.fileName(allImage[i],['doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'bmp', 'txt', 'JPG', 'gif', 'GIF', 'svg', 'rm', 'rmvb', 'mpeg', 'avi', 'mp4', '3gp', 'flv', 'wmv', 'swf', 'mpg', '3gp2', 'asf', 'mpeg1', 'mpeg2', 'mpeg3', 'mpeg4', 'h264', 'flv1', 'ppt', 'pptx', 'vsd', 'pot', 'pps', 'rtf', 'wps', 'et', 'dps', 'txt', 'epub', 'rar', 'rar5', 'zip', '7z','BMP','JFIF','bmp','jfif','ico','tif','webp']) + '","status":"done","url":"' + allImage[i] + '"},';
                            }
                            arr = arr.substring(0, arr.length - 1) + "]}";
                            arr = JSON.parse(arr).filelist;
                            _FeedBackDawer.setState({
                                fileList: arr
                            })
        
                        }else{
                            _FeedBackDawer.setState({
                                fileList: []
                            })
                        }
                        //延时赋值
                        setTimeout(() => {
                            _FeedBackDawer.props.form.setFieldsValue({
                                paymentMoney:data[0].CP_PayAmount,
                                Postscript:data[0].Comment,
                            })
                        }, 200);
                        _FeedBackDawer.getAppovel()
                }
               
               
            },
            error: function (data) {
                // history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    getRole(){
        $.ajax({
            url: Hcurl + '/Business/CheckHasRefundRole',
            type: "get",
             headers: {
                 "token": EventSet.getUserInfo()['token']
             },
            data: {
                comCode: JSON.parse(localStorage.getItem("userInfo")).xxhjcompanycode,
            },
            success: function (data) {
                if(data>0){
                    _FeedBackDawer.setState({
                        checkState:false
                    })
                }else{
                    _FeedBackDawer.setState({
                        checkState:true
                    })
                }
               
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    // 设置表格行类名
    setRowClass(record){
        return (record.isDealOverDue && record.isDealOverDue == 1) ? 'dealOverDue' : ''
    }
    render() {
        const { pagetotalCount, pagination } = this.state
        this.columns = [{
            title: '信息提示',
            dataIndex: 'AF_CasePress',
            render: (text, record, index) => {
                return (
                    <div>
                        {record.AF_CasePress_count.toString() !== "0" ?
                            <Tooltip title={record.AF_CasePress} arrowPointAtCenter={true} placement="top">
                                <img src={cuiBan} style={{ width: '16px' }} />
                            </Tooltip> : ""}
                    </div>
                )
            },
            width: 100,
            key: "0",
            fixed:'left'
        },
        {
            title: '登记编号',
            fixed:'left',
            render: (text, record, index) => {
                return (
                    <div>
                        <a style={{ marginRight: 10 }} onClick={v => this.ModalCase(record)}>{record.CI_Code}</a>
                    </div>
                )
            },
            width: 170,
            key: "1"
        },
        {
            title: '信息类别',
            dataIndex: 'CI_Type',
            key: "11",
            width:180
        },
        {
            title: '投诉人姓名',
            dataIndex: 'CI_UserName',
            key: "2",
            width:180
        },
        {
            title: '联系电话',
            dataIndex: 'CI_UserPhone',
            key: "3",
            width:100
        },
        {
            title: '申诉次数',
            dataIndex: 'Count',
            key: "4",
            width:100

        }, {
            title: '商品/服务名称',
            dataIndex: 'CI_ShopName',
            key: "5",
            width:200

        }, {
            title: '接收时间',
            dataIndex: 'CI_ComReceiveTime',
            sorter: true,
            key: "6",
            width:180,
            render:(text, record, index)=>{
                if(record.CI_ComReceiveTime!=''&&record.CI_ComReceiveTime!=null){
                    return (record.CI_ComReceiveTime.substring(0,16))
                }else{
                    return ('-')
                }
               
            }
        },
        {
            title: '办理期限',
            dataIndex: 'CI_DealEndDate',
            sorter: true,
            key: "7",
            width:180,
            render:(text, record, index)=>{
                if(record.CI_DealEndDate!=''&&record.CI_DealEndDate!=null){
                    return (record.CI_DealEndDate.substring(0,16))
                }else{
                    return ('-')
                }
               
            }
        },
        {
            width: 250,
            title: '操作',
            fixed:'right',
            render: (text, record, index) => {
                return (
                    <div >
                        <a style={{ marginRight: 10 }} onClick={() => this.onEditClick(record)}>{record.isReceive.toString() == "1" ? "确认接收" : "反馈"}</a>
                        <a style={{ color: '#ccc' }}>|</a>
                        {/* display: "inlineBlock", */}
                        <a onClick={() => this.onReturnBack(record)} style={{  marginLeft: 10, marginRight: 10, whiteSpace:"nowrap" }}>退回</a>
                        <a style={{ color: '#ccc' }}>|</a>
                        <a onClick={() => this.onRefuse(record)} style={{ display: "inlineBlock", marginLeft: 10 }}>拒绝和解</a>
                    </div>
                )
            },
            key: "8"
        }];
        return (
            <div style={{ position: "relative" }}>
                <Modal
                    width='1000px'
                    title="查看"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                    footer={[
                        <Button key="submit" onClick={this.handleOk}>
                            返回列表
                         </Button>,

                    ]}
                >

                </Modal>

                <ReturnBackWrapper />
                <RefuseBackWrapper />
                <LocaleProvider locale={zhCN}>
                    <Table
                        columns={this.columns}
                        rowClassName={this.setRowClass}
                        dataSource={this.state.data}
                        rowKey={record => record.CI_Code}
                        onChange={this.handleTableChange}
                        pagination={this.state.pagination}
                        loading={this.state.loading}
                        size="middle"
                        scroll={{ x: 1200 }}
                        bordered
                    />

                </LocaleProvider>
                <span className='tableTotal' style={{ display: this.state.display }}>
                    共 {pagetotalCount} 条记录 第 {pagination.current} / {pagination.total % pagination.pageSize == 0 ? Math.floor(pagination.total / pagination.pageSize) : Math.floor(pagination.total / pagination.pageSize) + 1} 页</span>
            </div>
        )
    }
}
var _companyList = null;
var ValueArray = [{
    Code: "",
    UserName: "",
    UserPhone: "",
    BusinessCode: ""
}]
class App extends Component {
    state = {
        autoHeight: "",
        companyList: 0,//没有选择企业
        span: 24,
        companyAllList: [],//已选企业列表
        display: "none",
        disabled: true,
        //_isMounted: false
    }
    to3() {
        history.push({
            pathname: '/Home/son3',
        })
    }


    autoHeight = () => {  //内容区域高度自适应
        let autoHeight = window.innerHeight - 429;
        this.setState({
            autoHeight: autoHeight
        })
    }

    //获取到的所有企业
    GetSelectCompany = () => {
        $.ajax({
            url: Hcurl + '/Business/GetSelectCompany?UserCode=' + EventSet.getUserInfo().CU_Code + '&Type=' + 1,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                if (data != null && data != []) {
                    data = JSON.parse(data)
                    _CompanyModalList.setState({
                        dataCheck: data
                    });
                    //_CompanyModalList.setState({
                    //    saveValue: data.map(function (item, idx) {
                    //        return data[idx].Com_CodeAndName
                    //    })
                    //})

                    companyCode = data.map(function (ds) {
                        return ds.Com_Code
                    })
                    companyCode = companyCode.toString();
                    setTimeout(() => {
                        _companyList.tableData()
                    }, 20)
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })

    }

    //获取用户上次选择的企业
    chooseCompanyPrv = () => {
        $.ajax({
            url: Hcurl + '/Business/GetUserDefaultCompanys?CU_Code=' + EventSet.getUserInfo().CU_Code + '&Type=' + "1",
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                if (data !== "" && data !== null) {
                    if (data.split('|')[0] !== 'false' && data != "0") {
                        data = JSON.parse(data);
                        companyCode = data.map(function (ds) {
                            return ds.Com_Code;
                        })
                        companyCode = companyCode.toString();//获取上次选择的企业code
                        let companyAllList = data.map(function (ds) {
                            return ds.Com_Name
                        });
                        _companyList.setState({
                            companyAllList: companyAllList.toString().replace(/,/g, ' ; '),
                            companyList: 1,
                            span: 22,
                        })
                        _CompanyModalList.setState({
                            saveValue: data.map(function (item, idx) {
                                return data[idx].Com_CodeAndName
                            }),

                        })
                        setTimeout(() => {
                            $.ajax({
                                url: Hcurl + '/Business/GetSelectCompany?UserCode=' + EventSet.getUserInfo().CU_Code + '&Type=' + 1,
                                type: "get",
                                headers: {
                                    "token": EventSet.getUserInfo()['token']
                                },
                                success: function (data) {
                                    if (data != null && data != []) {
                                        data = JSON.parse(data)
                                        _CompanyModalList.setState({
                                            dataCheck: data
                                        });
                                        setTimeout(() => {
                                            _companyList.tableData()
                                        }, 20)
                                    }
                                },
                                error: function (data) {
                                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                                }
                            })
                        }, 20);
                    }
                    else {
                        _companyList.GetSelectCompany()
                    }


                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })

            }
        })
    }
    chooseCompany = () => {  //选择企业
        _companyList.chooseCompanyPrv();
        //companyCode = "";
        _CompanyModalList.setState({
            visible: true,
        });
        _CompanyModalList.setState({
            value: _CompanyModalList.state.saveValue
        })
        if (_CompanyModalList.state.saveValue.length > 0) {
            _CompanyModalList.setState({
                disabled: false
            })
        } else {
            _CompanyModalList.setState({
                disabled: true
            })
        }
    }
    //组件加载完成后
    componentDidMount() {
        ValueArray = [{
            Code: "",
            UserName: "",
            UserPhone: "",
            infoClass:"",
        }]
        //this.setState({
        //    _isMounted: true
        //})
        setTimeout(() => {
            _companyList.chooseCompanyPrv(); //获取用户上次选择的企业
        }, 20);
        setTimeout(function () {
            if (_this.state.data.length !== 0) {
                var i = 0;
                (_this.state.data).map(function (ds) {
                    if (ds.isReceive == "1") {
                        i++;
                    }
                });
                if (i == 0)
                    _companyList.setState({ disabled: true })
            } else {
                _companyList.setState({ disabled: true })
            }

        }, 900);
        _companyList = this;
        this.autoHeight();
        EventSet.NavShow(this, "/Content/Business/CompromiseListWait", "Compromise")//显示菜单
        let t = JSON.parse(localStorage.userInfo)
        let token = t.token
        $.ajax({
            url: Hcurl + '/AF_CompanyCaseInfo/GetUnDealCaseCount',
            type: 'POST',
            data:{
                userCode: EventSet.getUserInfo().CU_Code,
                companyCode:EventSet.getUserInfo().xxhjcompanycode
            },
            headers: {
                "token": token
            },
            success: function (res) {
                if (res!='0') {
                     _companyList.openNotification();
                }
            },
            error: function (res) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    componentWillUnmount() {
        //this.setState({
        //    _isMounted: false
        //})
    }
    tableData = () => {   //获取列表数据
        _this.setState({ loading: true });
        const pagination = { ..._this.state.pagination };
        

        const _data = {CI_Code: ValueArray[0].Code,
            CI_UserName: ValueArray[0].UserName,
            CI_UserPhone: ValueArray[0].UserPhone,
            CI_BusinessCode: EventSet.getUserInfo()['xxhjcompanycode'],
            CI_Type:ValueArray[0].infoClass,
            userCode : EventSet.getUserInfo()['CU_Code'],
            pageNo: pagination.current,
            pageSize: pagination.pageSize,
            order: _this.state.sorters}
        $.ajax({
            url: Hcurl + '/Business/GetModelByBusinessPending',
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            data: _data,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {

                if (data != null && data != '') {
                    _this.setState({
                        data: data.Table,
                        pagetotalCount: data.Table2[0].Column1,
                        pagination: pagination,
                    })
                    if (data.Table.length !== 0) {
                        _this.setState({
                            display: "block",
                        })
                    } else {
                        _this.setState({
                            display: "none",
                        })
                    }
                    pagination.total = data.Table2[0].Column1;
                }
                _this.setState({
                    loading: false,
                })
                setTimeout(function () {
                    if (data != null && data != '') {
                        if (data.Table1[0].Column1 > 0) {
                            _companyList.setState({ disabled: false })
                        } else {
                            _companyList.setState({ disabled: true })
                        }
                    }
                }, 20);
            },
            error: function (res) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })

            }
        })
    }

    //查询条件搜索
    searchClick = () => {
        const { form } = this.props;
        form.validateFields((err, fieldsValue) => {
            const values = {
                ...fieldsValue,
            };
            ValueArray[0].Code = values.Code;
            ValueArray[0].UserName = values.Name;
            ValueArray[0].UserPhone = values.Phone;
            ValueArray[0].infoClass = values.infoClass;
            const pagination = { ..._this.state.pagination };
            pagination.current = 1;
            _this.setState({
                pagination: pagination
            })
            setTimeout(function () {
                _companyList.tableData();
            }, 20)

        })
    }
    //重置搜索调解
    reSet = () => {
        this.props.form.resetFields();
    }
    feedback=()=>{
        _FeedBackDawer.setState({
            visible:true
        })
    }
    //提醒弹窗通知
    openNotification = () => {
        var tipsText = '';
        let t = JSON.parse(localStorage.userInfo)
        let token = t.token
        $.ajax({
            url: Hcurl + '/AF_CompanyCaseInfo/GetNoticeMessage',
            async:false,
            headers: {
                "token": token
            },
            type: 'post',
            success: function (res) {
                tipsText = res.replace(/\n/g,'臡');
            }
        })
        Modal.info({
            title: '通知提醒',
            okText:'确定',
            content: (
                <div>
                    {tipsText.split('臡').map((item)=>{
                    return (<p style={{margin:'0'}}>{item}</p>)
                    })}
                </div>
            ),
        });
    };

    //批量接收方法
    AllReceived = () => {
        confirm({
            title: '批量接收',
            content: '确定批量接收所有未接收的业务单吗？',
            okText:'确认',
            cancelText:'取消',
            onOk() {
                var tel = [];
                $.ajax({
                    url: Hcurl + '/Business/ConfirmReceive',
                    type: "post",
                                            headers: {
                                                "token": EventSet.getUserInfo()['token']
                                            },
                    data: {
                        Code: "",//传空
                        ModuleID: "",
                        UserCode: EventSet.getUserInfo().CU_Code,//当前登录人Code
                        CI_DealDeapartCode: EventSet.getUserInfo().xxhjcompanycode,//企业Code
                        UserIp: "",
                        JoinMan: EventSet.getUserInfo().userName,//当前登录人名称
                        CP_Result: "",
                    },
                    headers: {
                        "token": EventSet.getUserInfo()['token']
                    },
                    success: function (data) {
                        if (data.indexOf('true')>=0) {
                            tel = data.split('|')[1];
                            message.success("提交成功");
                            _companyList.setState({
                                disabled: true
                            })
                            // $.ajax({
                            //     url: data_Url + 'WisdomAPI.ashx',
                            //     //url: "http://localhost:5113/ashx/WisdomAPI.ashx",
                            //     type: "post",
                            //                 headers: {
                            //                     "token": EventSet.getUserInfo()['token']
                            //                 },
                            //     dataType: "jsonp",
                            //     jsonp: "callback",
                            //     jsonpCallback: "successcallback",
                            //     async: false,
                            //     cache: false,
                            //     data: {
                            //         doType: "SendTemplateMessage",
                            //         CIID: tel,
                            //         tele: '',//tel.replace(/,/g, ';'),
                            //         msg: "",
                            //         templateCode: "20171202012",
                            //         isPostWxMessage: 1,
                            //         UserName: EventSet.getUserInfo().userName,
                            //         UserCode: EventSet.getUserInfo().CU_Code,
                            //         IP: localStorage.getItem('userIp'),
                            //         userType: 2,//企业传2，部门传1
                            //         isMultiReceive: 1,//专用于批量接收字段
                            //     },
                            //     success: function (data) {
                            //     },
                            //     error: function (data) {
                            //     }
                            // })
                            _companyList.tableData()
                        }
                    },
                    error: function (data) {
                        history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    }
                })
            },
            onCancel() {

            }
        })
    }
    render() {
        const { autoHeight, span } = this.state;
        const style = {
            minHeight: autoHeight
        };
        const formItemLayout = {
            labelCol: {
                xxl: { span: 4 },
                xl: { span: 6 },
                lg: { span: 8 },
                md: { span: 10 },
            },
            wrapperCol: {
                xxl: { span: 18 },
                xl: { span: 16 },
                lg: { span: 14 },
                md: { span: 10 },
            }
        };
        const style1 = {
            marginRight: 25,
        };
        const { getFieldDecorator } = this.props.form;
        return (
            <div id={'Company'} >
                <Crumbs title={"先行和解 / 待处理"} />
                <CompanyModalList />
                <CaseDetailsInfoModal />
                <div className={'Company'} style={style}>
                    <Form onSubmit={this.handleSubmit} className='formSearch' style={{ marginLeft: 10 }}>
                        <Row>
                            <Col span={8}>
                                <FormItem
                                    label="登记编号"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('Code')(
                                        <Input placeholder='请输入登记编号' />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="投诉人姓名"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('Name')(
                                        <Input placeholder='请输入投诉人姓名' />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="投诉人电话"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('Phone')(
                                        <Input placeholder='请输入投诉人电话' />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8}>
                                <FormItem
                                    label="信息类别"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('infoClass',{initialValue:''})(
                                        
                                        <Select placeholder='请选择信息类别'>
                                        <Option key={1} value="">全部</Option>
                                        <Option key={2} value="投诉">投诉</Option>
                                        <Option key={3} value="无理由退货">无理由退货</Option>
                                      </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={16}>
                            <div className='searchBtn'>
                            <span className='searchSpan'>
                                <Button type="primary" htmlType="submit" style={style1} onClick={this.searchClick}>搜索</Button>
                                <Button type="" onClick={this.reSet}>重置</Button>
                                {/* <Button type="" onClick={this.feedback}>反馈</Button> */}
                            </span>
                            </div>
                            </Col>
                          
                        </Row>
                       
                    </Form>
                    <div style={{ width: "95%", margin: "0 auto" }}>
                        <div style={{ marginTop: 30 }}>
                            <Row>{this.state.companyList === 0 ?
                                "" : <Col span={8} >
                                    <Button onClick={this.AllReceived} disabled={this.state.disabled}>批量接收</Button> 
                                    <div className='tagColor'><span></span>橙色表示当前工单即将到期，请尽快处理。</div>
                                </Col>}
                                {/* <Col span={span}>
                                    <div className='AlertInfo'>
                                        <img src={companyCase} className='imgCompanyCase' alt='图片' />
                                        {this.state.companyList === 0 ? <span className='hasSpan'>未选择任何企业</span> : <span className='hasSpan'>已选：<span style={{
                                            color: 'rgba(0, 0, 0, 0.647058823529412)', display: "inline-block", width: "80%", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', position: "absolute"
                                        }}>{this.state.companyAllList}</span></span>}
                                        <div className='chooseCompany' onClick={this.chooseCompany}>选择企业</div>
                                    </div>

                                </Col> */}
                            </Row>
                        </div>
                        <div className='TableWaper' style={{ width: "100%" }}>
                            <TableWaper />
                        </div>
                    </div>
                    <FeedBackDawerWrapper/>
                </div>


            </div>
        );
    }
}
const AppWrapped = Form.create()(App);
export default connect()(AppWrapped)


// WEBPACK FOOTER //
// ./src/components/Content/Business/Compromise/CompromiseListWait/CompromiseListWait.js